import PaymentController from './payment.model';

export default class PaymentCreditMachineController extends PaymentController {
  _data_credit = {
    payment_installments: null,
    card_brand: null,
    payment_receipt: {
      document_number: null,
      authorization_number: null
    }
  }
  _data = {
    ...this._data, // usa o objeto herdado
    ...this._data_credit
  }


  constructor(input) {
    super(input)
    this._data.payment_type = "credit_card_machine"

    this.setData(input, this._data)
  }
}